import { HostedPage } from '@/views/Hosted';

export default function CommerceLandingPage() {
  return <HostedPage />;
}
